/**
 * Simple Markdown Parser (RegEx based)
 * Shared between AdminDocsPage and MarkdownModal
 */
const parseMarkdown = (text) => {
    if (!text) return '';

    let html = text
        // Headers (Block elements - no wrapping needed)
        .replace(/^# (.*$)/gim, '<h1 class="text-2xl font-bold mb-4 border-b pb-2 pt-4">$1</h1>')
        .replace(/^## (.*$)/gim, '<h2 class="text-xl font-bold mb-3 mt-6">$1</h2>')
        .replace(/^### (.*$)/gim, '<h3 class="text-lg font-bold mb-2 mt-4">$1</h3>')

        // Lists
        .replace(/^\s*-\s(.*$)/gim, '<li class="ml-4 list-disc mb-1">$1</li>')
        .replace(/^\s*\d\.\s(.*$)/gim, '<li class="ml-4 list-decimal mb-1">$1</li>')

        // Formatting
        .replace(/\*\*(.*)\*\*/gim, '<strong class="font-bold">$1</strong>')
        .replace(/\*(.*)\*/gim, '<em class="italic">$1</em>')
        .replace(/`(.*?)`/gim, '<code class="bg-gray-100 dark:bg-zinc-800 px-1 py-0.5 rounded font-mono text-sm text-pink-600 dark:text-pink-400">$1</code>')

        // Images (Must be before links)
        .replace(/!\[(.*?)\]\((.*?)\)/gim, '<img src="$2" alt="$1" class="max-w-full rounded-lg my-2 shadow-sm" onerror="this.style.display=\'none\'">')

        // Links
        .replace(/\[(.*?)\]\((.*?)\)/gim, '<a href="$2" target="_blank" class="text-blue-600 dark:text-blue-400 hover:underline">$1</a>')

        // Newlines: Simple BR replacement. No P tags to avoid "P > H1" invalid nesting.
        .replace(/\n/gim, '<br>');

    // Wrap in a DIV, not P.
    return `<div class="markdown-body leading-relaxed">${html}</div>`;
};

export { parseMarkdown };
